export default __webpack_public_path__ + "static/media/Vector-representation.cbfbbf00.jpg";